function EmbeddedIframeCtrl($scope, $sce, $timeout, $window) {
  if (!$scope.iframeUrl) throw new Error('embeddedIframeCtrl - constructor() - iframeUrl required on scope');

  _initScope();

  function _initScope() {
    $scope.loading = true;
    $scope.reloading = false;

    $scope.iframeUrlSafe = $sce.trustAsResourceUrl($scope.iframeUrl);

    $scope.refreshIframe = _refreshIframe;
    $scope.openUrl = _openUrl;

    $scope.screenSizes = [{
      icon: 'ion-android-desktop',
      size: 'lg',
      order: 4
    }, {
      icon: 'ion-ipad',
      size: 'md',
      order: 3
    }, {
      icon: 'ion-android-phone-landscape',
      size: 'sm',
      order: 2
    }, {
      icon: 'ion-android-phone-portrait',
      size: 'xs',
      order: 1
    }];

    $scope.currentScreenSizeForm = {
      currentSize: $scope.screenSizes[1]
    };

    $scope.iframeLoaded = _iframeLoaded;
  }

  function _openUrl($event) {
    if ($event) $event.preventDefault();

    $window.open($scope.iframeUrl);
  }

  function _refreshIframe($event) {
    if ($event) $event.preventDefault();

    const iframeUrlSafe = $scope.iframeUrlSafe;

    delete $scope.iframeUrlSafe;

    $scope.reloading = true;
    $scope.loading = true;

    $timeout(() => {
      $scope.reloading = false;
      $timeout(() => {
        $scope.iframeUrlSafe = iframeUrlSafe;
      });
    });
  }

  function _iframeLoaded() {
    $timeout(() => {
      $scope.loading = false;
    });
  }
}

EmbeddedIframeCtrl.$inject = [
  '$scope',
  '$sce',
  '$timeout',
  '$window'
];

export default EmbeddedIframeCtrl;



// WEBPACK FOOTER //
// ./src/directives/embeddedIframe/controller.js